
  <div nz-row class="flex flex-dir-vert flex-horiz-space-bw">
    <h2 class="heading-mms">Today's Summary / Activities</h2>
    <!--<nz-range-picker style="align-self: flex-end; margin-top: -30px"
            [nzShowTime]="{ nzFormat: 'HH:mm' }"
            nzFormat="yyyy-MM-dd HH:mm"
            [nzPlaceHolder]="[ 'Start Time', 'End Time' ]"
            data-ngModelChange="onChange($event)"
            data-nzOnOk="onOk($event)"
    >
    </nz-range-picker>-->
  </div>

  <div nz-row class="p-t-40">

    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
      <nz-timeline>

        <nz-timeline-item nzColor="blue">
          <p>
            <nz-avatar nzSize="small" nzIcon="anticon anticon-user"
                       nzSrc="https://randomuser.me/api/portraits/men/33.jpg"></nz-avatar> Ryan Matthew (LEAD)
            - Meeting scheduled at
            <nz-tag [nzColor]="'blue'">11:20 AM</nz-tag>
          </p>
        </nz-timeline-item>

        <nz-timeline-item nzColor="blue">
          <p>
            <nz-avatar nzSize="small" nzIcon="anticon anticon-user"
                       nzSrc="https://randomuser.me/api/portraits/women/33.jpg"></nz-avatar> Lina Rebecca (LEAD)
            - Meeting scheduled at
            <nz-tag [nzColor]="'blue'">12:25 PM</nz-tag>
          </p>
        </nz-timeline-item>

        <nz-timeline-item>
          <p>
            <nz-avatar nzSize="small" nzIcon="anticon anticon-user"
                       nzSrc="https://randomuser.me/api/portraits/men/74.jpg"></nz-avatar> Michael Hendrix's
            <b href="javascript:void(0)">Health Policy (H20090011-21)</b> is pending premium payment
          </p>
        </nz-timeline-item>

        <nz-timeline-item>
          <p>
            <nz-avatar nzSize="small" nzIcon="anticon anticon-user"
            ></nz-avatar> Serah Ann's
            <b href="javascript:void(0)">Health Policy (H2910991-29)</b> is pending premium payment
          </p>
        </nz-timeline-item>

        <nz-timeline-item>
          <p>
            <nz-avatar nzSize="small" nzIcon="anticon anticon-user"
                       nzSrc="https://randomuser.me/api/portraits/men/10.jpg"></nz-avatar> Jimmy Kimmel (LEAD)
            - Meeting scheduled at
            <nz-tag [nzColor]="'blue'">4:10 PM</nz-tag>

          </p>
        </nz-timeline-item>

      </nz-timeline>
    </div>

    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">

      <div class="flex flex-dir-row flex-horiz-space-bw">
        <div>
          <h3>Hello, John!</h3>
          <p>
            Here's a quick glance at this month so far:
          </p>
        </div>
        <div style="line-height: .51rem;">
          <b style="font-size: 20px">Jakarta, ID ~ 24 °C</b>
          <br />
          Slightly cloudy <i nz-icon nzType="cloud" nzTheme="outline" style="font-size: 36px"></i>
        </div>
      </div>

      <!--<ngx-charts-advanced-pie-chart class="m-t-b-20" [results]="chartss" [scheme]="colorScheme">
      </ngx-charts-advanced-pie-chart>-->
      <div class="flex">
        <ngx-charts-number-card [results]="chartss" [scheme]="colorScheme" [innerPadding]="25">
        </ngx-charts-number-card>

        <div>&nbsp;</div>
      </div>

      <div class="flex">

        <nz-timeline>

          <nz-timeline-item nzColor="blue">
            <p>
              Activities: <b>23</b> / 55 done
            </p>
          </nz-timeline-item>

          <nz-timeline-item nzColor="blue">
            <p>
              You have met <b>60%</b> of your monthly target
            </p>
          </nz-timeline-item>

        </nz-timeline>

      </div>

    </div>

    <!-- Ananytics -->

    <div nz-col nzSpan="24" class="m-t-b-20">
      <nz-divider nzDashed [nzText]="text">
        <ng-template #text><i nz-icon nzType="plus"></i></ng-template>
      </nz-divider>
    </div>


    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="8" nzXl="8">
      <h3 class="m-b-30 heading-mms">Your Statistics</h3>
      <nz-timeline>

        <nz-timeline-item nzColor="blue">
          <p>
            Your average time to <b>close a lead</b> is <b>2 days</b>
          </p>
        </nz-timeline-item>

        <nz-timeline-item nzColor="blue">
          <p>
            Your average time to <b>create a quote</b> is <b>6 minutes</b>
          </p>
        </nz-timeline-item>

        <nz-timeline-item nzColor="blue">
          <p>
            Your average <b>policy value sold</b> is <b>$750</b>
          </p>
        </nz-timeline-item>

        <nz-timeline-item nzColor="blue">
          <p>
            Your average <b>monthly commission</b> is <b>$8,980</b>
          </p>
        </nz-timeline-item>

      </nz-timeline>
    </div>

    <div nz-col nzXs="12" nzSm="12" nzMd="12" nzLg="10" nzXl="10">

      <h3 class="m-b-30 heading-mms">Your Sales Funnel</h3>

      <div class="m-b-30">
        <a href="javascript:void(0)">This month</a>
        <nz-divider nzType="vertical"></nz-divider>
        <b>3 months</b>
        <nz-divider nzType="vertical"></nz-divider>
        <a href="javascript:void(0)">6 months</a>
      </div>
      <div class="funnel_outer m-b-40">
        <ul>
          <li class="funnel_step_1"><span><p>103 leads
                                    <br><small>Total </small></p></span></li>
          <li class="funnel_step_2"><span><p>58 quotes
                                <br><small>56% conversion</small></p></span> </li>
          <li class="funnel_step_3"><span><p>29 policies
                                <br><small>50% conversion</small></p></span></li>
        </ul>
      </div>

    </div>

    <div nz-col nzXs="12" nzSm="12" nzMd="12" nzLg="6" nzXl="6">
      <h3 class="m-b-20 heading-mms">Your Reporting Structure</h3>
      <nz-tree
              [nzData]="nodes"
              nzShowIcon="true"
      >
      </nz-tree>
    </div>

  </div>

  <div nz-row>

    <div nz-col nzSpan="24" class="m-b-20">
      <nz-divider nzDashed [nzText]="text">
        <ng-template #text><i nz-icon nzType="plus"></i></ng-template>
      </nz-divider>
    </div>

    <div nz-col nzSpan="24">
      <h2 class="heading-mms">My Commissions</h2>
    </div>

    <div nz-row class="p-t-40">

      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
        <div nz-row>
          <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
            <div class="widget-small-analytics">
              <div class="content">
                <div nz-row>
                  <div nz-col nzMd="16">
                    <div class="numbers">
                      <p>This Month <span></span></p>
                      <strong class="color-blue">$ 6,803</strong>
                    </div>
                  </div>
                  <div col nzMd="8">
                    <div class="icon-big icon-warning text-center">
                      <i nz-icon nzType="dollar" nzTheme="twotone"></i>
                    </div>
                  </div>
                </div>
                <div class="widget-small-footer">
                  <div class="stats">
                    Assessment: On track for monthly goal
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
            <div class="widget-small-analytics">
              <div class="content">
                <div nz-row>
                  <div nz-col nzMd="16">
                    <div class="numbers">
                      <p>All Time <span></span></p>
                      <strong class="color-">$ 84,479</strong>
                    </div>
                  </div>
                  <div col nzMd="8">
                    <div class="icon-big icon-warning text-center">
                      <i nz-icon nzType="wallet" nzTheme="outline"></i>
                    </div>
                  </div>
                </div>
                <div class="widget-small-footer">
                  <div class="stats">
                    You are among the <b>top 2 percent</b> of earners !
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div nz-row>
          <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
            <div class="widget-small-analytics">
              <div class="content">
                <div nz-row>
                  <div nz-col nzMd="16">
                    <div class="numbers">
                      <p>Points <span>un-redeemed</span></p>
                      <strong class="color-">4,500</strong>
                    </div>
                  </div>
                  <div col nzMd="8">
                    <div class="icon-big icon-warning text-center">
                      <i nz-icon nzType="profile" nzTheme="outline"></i>
                    </div>
                  </div>
                </div>
                <div class="widget-small-footer">
                  <div class="stats">
                    You are just <b>1500 points away</b> from the next milestone
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
            <div class="widget-small-analytics">
              <div class="content">
                <div nz-row>
                  <div nz-col nzMd="16">
                    <div class="numbers">
                      <p>Level <span></span></p>
                      <strong class="color-">SILVER</strong>
                    </div>
                  </div>
                  <div col nzMd="8">
                    <div class="icon-big icon-warning text-center">
                      <i nz-icon nzType="crown" nzTheme="outline"></i>
                      <!--<i nz-icon nzType="gift" nzTheme="outline"></i>-->
                    </div>
                  </div>
                </div>
                <div class="widget-small-footer">
                  <div class="stats">
                    <b>Next Milestone</b>: Weekend getaway to a 4-star resort in your city <b>[6000 points]</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" class="flex" style="min-height: 300px">
        <ngx-charts-line-chart
                [scheme]="colorScheme"
                [results]="chart_commissions"
                [gradient]="true"
                [xAxis]="true"
                [showGridLines] = "true"
                [yAxis]="true"
                [legend]="false"
                [showXAxisLabel]="true"
                [showYAxisLabel]="false"
                [xAxisLabel]="'Commissions'"
                [autoScale]="true"
        >
        </ngx-charts-line-chart>
      </div>

    </div>

  </div>

  <div nz-row>

    <div nz-col nzSpan="24" class="m-t-b-20">
      <nz-divider nzDashed [nzText]="text">
        <ng-template #text><i nz-icon nzType="plus"></i></ng-template>
      </nz-divider>
    </div>


    <div nz-col nzMd="24">
      <h3 class="m-b-30 heading-mms">Opportunities</h3>
    </div>

    
    <div class="flexie-auto-grid d-block d-b">

    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
      <nz-list class="m-b-40 m-r-30" [nzDataSource]="data_itemCrossSell" nzBordered nzSize="small"
               [nzHeader]="'Cross-sell Opportunities'"
               [nzRenderItem]="itemCrossSell">
        <ng-template #itemCrossSell let-item>
          <nz-list-item [nzContent]="item">
            <div class="p-r-15">
              <a href="javascript:void(0)"><i nz-icon nzType="phone" nzTheme="outline"></i> Call Now</a> |
              <a href="javascript:void(0)"><i nz-icon nzType="calendar" nzTheme="outline"></i> Add as Activity</a>
            </div>
          </nz-list-item>
        </ng-template>
      </nz-list>
    </div>

    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
      <nz-list class="m-b-40 m-r-20 m-b-20" [nzDataSource]="data_itemUpSell" nzBordered nzSize="small"
               [nzHeader]="'Top Leads to sell to'"
               [nzRenderItem]="itemCrossSell">
        <!-- Template from cross-sell -->
      </nz-list>
    </div>

    </div>

  </div>

  <!-- Hidden Content -- DRAWERS -->
  <nz-drawer [nzClosable]="true" [nzWidth]="340" [nzVisible]="introDrawer" [nzPlacement]="'right'" nzTitle="Welcome!" (nzOnClose)="closeIntroDrawer()">
    <img src="/assets/images/{{organizationMetaData.logoname}}" alt="" style="width:100%;" />
    <img src="/assets/images/intro-illus.png" alt="" style="width:100%;" />
    <h3>Hello, you seem new here</h3> 
    <p>We've made the portal with great care, and things should be a breeze even for first-time users. Still, if you need any help, these might be of help to you:</p>
    <ul>
      <li><a>Intro video</a></li>
      <li><a>KB: Getting started</a></li>
      <li><a>Underwriting Portal FAQs</a></li>
    </ul>
    <p>
      <button nz-button nzType="primary" (click)="closeIntroDrawer()">Got it!</button>
    </p>
  </nz-drawer>
  <!-- END Hidden Content -->




